"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.link");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Footer, _React$PureComponent);

  var _super = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          navLinks = _this$props.navLinks,
          socialMediaLinks = _this$props.socialMediaLinks,
          logoUrl = _this$props.logoUrl;
      var classes = (0, _classnames.default)(className, 'global-footer');
      return /*#__PURE__*/_react.default.createElement("footer", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "l-padding global-footer__content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "global-footer__logo",
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement("img", {
        width: "125",
        height: "35",
        src: logoUrl,
        alt: "iCare"
      })), /*#__PURE__*/_react.default.createElement("nav", {
        className: "global-footer__nav"
      }, /*#__PURE__*/_react.default.createElement("ul", null, navLinks.map(function (item, index) {
        var optionalAttributes = {};

        if (item.target === '_blank') {
          optionalAttributes.rel = 'noopener noreferrer';
        }

        return /*#__PURE__*/_react.default.createElement("li", {
          key: "global-footer__nav-item-".concat(index)
        }, /*#__PURE__*/_react.default.createElement("a", _extends({
          target: item.target,
          href: item.link,
          className: "hide-external"
        }, optionalAttributes), item.title));
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "global-footer__social"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "Social"), /*#__PURE__*/_react.default.createElement("nav", null, socialMediaLinks.map(function (link) {
        return /*#__PURE__*/_react.default.createElement("a", {
          key: link.href,
          href: link.href,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "hide-external",
          title: link.title
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: link.imageSource,
          alt: link.imageAlt
        }));
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "global-footer__copyright"
      }, /*#__PURE__*/_react.default.createElement("span", null, "\xA9 insurance & care NSW ", new Date().getFullYear())));
    }
  }]);

  return Footer;
}(_react.default.PureComponent);

exports.default = Footer;

_defineProperty(Footer, "propTypes", {
  className: _propTypes.default.string,
  navLinks: _propTypes.default.array,
  socialMediaLinks: _propTypes.default.array,
  logoUrl: _propTypes.default.string
});

_defineProperty(Footer, "defaultProps", {
  className: null,
  navLinks: [],
  logoUrl: require('@icare/core/statics/icons-social/icare-logo-white.svg').default,
  socialMediaLinks: [{
    href: 'http://www.facebook.com/icarensw/',
    title: 'Like us on facebook',
    imageSource: require('@icare/core/statics/icons-social/icon-facebook-colour.svg').default,
    imageAlt: 'icare on Facebook'
  }, {
    href: 'http://www.twitter.com/icareNSW',
    title: 'Like us on twitter',
    imageSource: require('@icare/core/statics/icons-social/icon-twitter-colour.svg').default,
    imageAlt: 'icare on Twitter'
  }, {
    href: 'http://au.linkedin.com/company/insurance-and-care-nsw/',
    title: 'Like us on linkedin',
    imageSource: require('@icare/core/statics/icons-social/icon-linkedin-colour.svg').default,
    imageAlt: 'icare on LinkedIn'
  }, {
    href: 'https://www.youtube.com/channel/UCEEja9i9uXGNXope5Ymq4Ww',
    title: 'Like us on youtube',
    imageSource: require('@icare/core/statics/icons-social/icon-youtube-colour.svg').default,
    imageAlt: 'icare on Youtube'
  }, {
    href: 'https://www.instagram.com/icarensw/',
    title: 'Like us on instagram',
    imageSource: require('@icare/core/statics/icons-social/icon-instagram-colour.svg').default,
    imageAlt: 'icare on Instagram'
  }]
});
//# sourceMappingURL=Footer.js.map